function bootApplication() { //eslint-disable-line no-unused-vars
    angular.bootstrap(document, ['TVG']);
}

require([
    'app'
], function () {
    initializeApp();
});

define("bootstrap", function(){});

